import Vue from 'vue';
import VueI18n from 'vue-i18n';

import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import viLocale from 'element-ui/lib/locale/lang/vi'
import locale from 'element-ui/lib/locale';
import { zh, en, vi } from './temp/test.json'
import store from '@/framework/store'

Vue.use(VueI18n);

// 组合语言包
// const messages = {
//  zh: {
//   ...zh,
//   ...zhLocale
//  },
//  en: {
//   ...en,
//   ...enLocale
//  },
//  vi: {
//   ...vi,
//   ...viLocale
//  }
// };

// 获取存储语言或浏览器语言
// const preferredLang = localStorage.getItem('preferred_lang');
// let lang = preferredLang || (navigator.language || navigator.browserLanguage).toLowerCase();
console.log(store, 'store');
console.log(lang, 'lang');
let vuexData = JSON.parse(localStorage.getItem('vuex') || '{}');
const lang = vuexData && vuexData.app && vuexData.app.lang || 'chinese';
const langMessages = vuexData && vuexData.app && vuexData.app.langMessages;
const messages = { 
    chinese: {
      ...zhLocale,
      ...(langMessages && langMessages.chinese || {}),
    },
    english: {
      ...enLocale,
      ...(langMessages && langMessages.english || {}),
    },
    vietnamese: {
      ...viLocale,
      ...(langMessages && langMessages.vietnamese || {})
    },
  }

// 创建 VueI18n 实例，并为 messages 和 locale 属性赋值
const i18n = new VueI18n({
  locale: lang,
  messages: messages,
  //  locale: lang.substr(0, 2)
});

// element国际化动态切换
locale.i18n((key, value) => i18n.t(key, value));


// 导出
export default i18n;
